export enum FormPageType {
    Entry = 1,
    Review = 2
}